import React, { FunctionComponent, useState } from 'react';
import { t } from 'autobiz-translate';
import { AutobizButton } from 'autobiz-strap';
import { FormGroup, Label, Input } from 'reactstrap';
import { auth0Credentials } from '../../../../config';
import AccessValidationWrapper from './AccessValidationWrapper';

const AcceptCgv: FunctionComponent = () => {
    const [accepted, setAccepted] = useState(false);

    const searchParams = new URLSearchParams(document.location.search);
    const state = searchParams.get('state');

    const { domain } = auth0Credentials;

    const handleClick = () => {
        const continueUrl = `https://${domain}/continue?state=${state}`;
        window.location.replace(continueUrl);
    };

    let wrapperProps = {};

    wrapperProps = {
        title: t('welcome_office'),
        label: t('acceptTermsOfSaleDescription1'),
        className: 'accessValidation-cgv',
    };

    return (
        <AccessValidationWrapper {...wrapperProps}>
            <main>
                <div
                    className="mt-3"
                    dangerouslySetInnerHTML={{
                        __html: t('acceptTermsOfSaleDescription2') || '',
                    }}
                />
                <p
                    dangerouslySetInnerHTML={{
                        __html: t('acceptTermsOfSaleDescription3') || '',
                    }}
                />
                <FormGroup className="mb-4">
                    <Label>
                        <Input
                            type="checkbox"
                            name="checkbox"
                            onClick={() => setAccepted(!accepted)}
                            style={{
                                width: 20,
                                height: 20,
                                marginLeft: '-1.75rem',
                                marginTop: 0,
                            }}
                        />{' '}
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t('acceptTermsOfSaleInput') || '',
                            }}
                        />
                    </Label>
                </FormGroup>
                <AutobizButton
                    type="button"
                    onClick={handleClick}
                    color="primary"
                    block
                    disabled={!accepted}
                >
                    {t('acceptTermsOfSaleContinue')}
                </AutobizButton>
            </main>
        </AccessValidationWrapper>
    );
};

export default AcceptCgv;
